import React from 'react'
import '../../scss/pages/Surveys/Surveys.scss'

function Surveys() {
    return (
        <div className='surveysContainer'>Surveys</div>
    )
}

export default Surveys